import { render, staticRenderFns } from "./FlowStepFreeformEmpty.vue?vue&type=template&id=56a7e913&"
import script from "./FlowStepFreeformEmpty.vue?vue&type=script&lang=js&"
export * from "./FlowStepFreeformEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports